<!--
 * @Author: 黄悦凯 huangyuekai@jafron.com
 * @Date: 2025-11-26 19:18:12
 * @LastEditors: 黄悦凯 huangyuekai@jafron.com
 * @LastEditTime: 2025-12-02 21:07:53
 * @FilePath: \to-consumer-h5\src\views\clockIn\material\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: 黄悦凯 huangyuekai@jafron.com
 * @Date: 2025-11-26 19:18:12
 * @LastEditors: 黄悦凯 huangyuekai@jafron.com
 * @LastEditTime: 2025-11-26 19:45:47
 * @FilePath: \to-consumer-h5\src\views\clockIn\material\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="container">
        <div class="card">
            <h3 style="margin-top: 0;font-size: 16px">素材收集</h3>

            <textarea v-model="content" class="input" rows="4" placeholder="素材信息"></textarea>

            <!-- Vue2 使用 v-model -->
            <ImageUploader v-model="images" />

            <div style="margin-top:12px">
                <button class="button" @click="submit">提交素材</button>
            </div>
        </div>

        <div class="card">
            <h4 style="margin: 0 0 12px;">我的提交</h4>
            <div v-for="item in list" :key="item.id" style="margin-top:10px" class="card-row">
                <div style="display:flex;gap:10px;align-items:center">
                    <div style="width:56px;height:56px;border-radius:8px;overflow:hidden;background:#f6fbff">
                        <img v-if="item.image_urls && item.image_urls.length" :src="item.image_urls[0]"
                            style="width:100%;height:100%;object-fit:cover" />
                    </div>
                    <div style="height: 56px;
                                    width: calc(100% - 66px);
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;">
                        <div style="font-weight:500;width: 90%;" class="two-line-ellipsis">{{ item.content || "" }}
                        </div>
                        <div class="muted small">{{ formatTime(item.created_at) }}</div>
                    </div>
                </div>

                <!-- <div class="small primary"  style="color: var(--accent);" @click="toDetail(item.id)">
                      查看
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import ImageUploader from "../components/ImageUploader.vue"
import { submitMaterial, getMyMaterials } from '../api/material'
import { toast } from "@/util/toast"

export default {
    name: "MaterialPage",

    components: {
        ImageUploader,
    },

    data() {
        return {
            content: "",
            images: [], // v-model 接收
            list: [],
        };
    },

    mounted() {
        this.loadList();
    },

    methods: {
        formatTime(iso) {
            try {
                return new Date(iso).toLocaleString();
            } catch (e) {
                return iso;
            }
        },
        async submit() {
            if (!this.content.trim()) {
                toast("请输入素材信息");
                return;
            }
            if (this.images.length === 0) {
                toast("请上传至少一张图片");
                return;
            }

            try {
                await submitMaterial({
                    content: this.content,
                    image_urls: this.images,
                });

                toast("素材提交成功");
                this.content = "";
                this.images = [];
                this.loadList();
            } catch (err) {
                console.error(err);
                toast(err.message || "素材提交失败，请重试");
            }
        },

        async loadList() {
            try {
                this.list = await getMyMaterials();
                console.log('materials', this.list);
            } catch (err) {
                console.error(err);
                toast(err.message || "获取素材记录失败");
            }
        },
        toDetail(id) {
            this.$router.push({ name: 'materialDetail', params: { id } });
        },
    },
};
</script>
<style scoped>
.container {
    padding: 16px;
    height: calc(100vh - 32px);
    background: linear-gradient(90deg, rgba(150, 226, 251, 0.2) 0%, rgba(183, 171, 236, 0.2) 100%);
}

/* Card */
.card {
    background: var(--card);
    border-radius: var(--radius-lg);
    padding: 14px;
    margin-bottom: 12px;
    box-shadow: var(--shadow-sm);
    overflow: hidden;
    -webkit-border-radius: var(--radius-lg);
    -moz-border-radius: var(--radius-lg);
    -ms-border-radius: var(--radius-lg);
    -o-border-radius: var(--radius-lg);
}

.card-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/* Buttons */
.button {
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 4px;
    background: var(--primary);
    color: #fff;
    border: 0;
    cursor: pointer;
    box-shadow: var(--shadow-xs);
    font-weight: 500;
    white-space: nowrap;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
}

a {
    text-decoration: none;
    color: #fff;
}

.ghost {
    background: transparent;
    color: var(--accent);
    border: 1px solid rgba(0, 160, 255, 0.12);
}

/* Input */
.input {
    font-size: 14px;
    width: 100%;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #edf2f7;
    background: #fbfdff;
    box-sizing: border-box;
}

.textarea {
    min-height: 96px;
    resize: vertical;
}

/* Image grid */
.img-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.img-grid img {
    width: 100%;
    height: auto;
}

.img-grid .thumb {
    width: calc(33.333% - 8px);
    aspect-ratio: 1/1;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    background: linear-gradient(180deg, #f8fbff, #eef7ff);
}

.img-grid .thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* thumb overlay (delete button) */
.thumb .delete {
    position: absolute;
    right: 6px;
    top: 6px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: 999px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
}

/* Skeleton */
.skeleton {
    background: linear-gradient(90deg, #f0f0f0, #f7f7f7, #f0f0f0);
    background-size: 200% 100%;
    animation: shimmer 1.2s linear infinite;
    border-radius: 8px;
}

.tips {
    color: var(--tips);
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

/* Tiny UI */
.row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.muted {
    color: var(--muted);
    font-size: 13px;
}

.small {
    font-size: 13px;
}

/* 两行省略 - 最常用 */
.two-line-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* 控制显示的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}
</style>
